import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';
import { KYMW9009Component } from './kymw9009.component';
import { GetOktaUserNameModel } from './vo/get-okta-user-name.model';
import { GetUserClassManagementModel } from './vo/get-user-class-management.model';
import { UserClassManagementModel } from './vo/user-class-management.model';
/**
 * ユーザ階層管理画面の値を管理するクラス
 *
 * @export KYMW9009Model
 * @class KYMW9009Model
 */
export class KYMW9009Model {

  /** 階層識別子の定数「Group」 */
  public static readonly CLASS_GROUP = <string>"Group";
  /** 階層識別子の定数「Staff」 */
  public static readonly CLASS_STAFF = <string>"Staff";
  /** 階層識別子の定数「Agent」 */
  public static readonly CLASS_AGENT = <string>"Agent";
  /** 階層名の定数「グループ長」 */
  public static readonly CLASS_GROUP_NAME = <string>"グループ長";
  /** 階層名の定数「担当者」 */
  public static readonly CLASS_STAFF_NAME = <string>"担当者";
  /** 階層名の定数「代行者」 */
  public static readonly CLASS_AGENT_NAME = <string>"代行者";


  /**
   * KYMW9009Component
   */
  public kymw9009Component: KYMW9009Component = null;

  /**
   * コンボボックス 「部門」
   */
  public classCode: string = <string>'';

  /**
   * データグリッド「ユーザ階層一覧」
   */
  public userClassList: Array<UserClassManagementModel>;

  /**
   * データグリッド「Oktaユーザ情報一覧」
   */
  public oktaInfoList: Array<any> = new Array<any>();


  /**
   * ユーザ階層取得条件
   */
  private getUserClassVO: GetUserClassManagementModel = new GetUserClassManagementModel();

  /**
   * データグリッド「ユーザ階層」を設定する
   *
   * @param {*} serverData サーバからのレスポンスのデータ部分
   * @param {GetUserClassManagementModel} requestVO サーバへのリクエスト内容
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public updateUserClassList(serverData: any, requestVO: GetUserClassManagementModel): void {
    this.userClassList = new Array<UserClassManagementModel>();

    // データをセット
    if (serverData != null) {
      // サーバーレスポンスデータ
      const tempUserClass: Array<any> = serverData.UserClassManagementList;
      // 権限による操作可否
      const disabled = this.kymw9009Component.isDispOnlyMode();

      // コントロールブレイク変数
      let breakClass = '';
      let breakGroup = '';
      let breakStaff = '';
      let breakAgent = '';
      let breakClassName = '';  // コントロールブレイクには使用しないがメッセージ表示のため

      for (let i = Number(0); i < tempUserClass.length; i++) {
        const uc: UserClassManagementModel = new UserClassManagementModel();
        uc.Disabled = disabled;

        uc.ClassCode = tempUserClass[i].ClassCode;
        uc.ClassName = tempUserClass[i].ClassName;

        uc.GroupUserId = tempUserClass[i].GroupLeaderUserId;
        uc.GroupUserIdOrigin = tempUserClass[i].GroupLeaderUserId;
        uc.GroupUserIdBeforeInput = tempUserClass[i].GroupLeaderUserId;
        uc.GroupUserName = tempUserClass[i].GroupLeaderUserName;
        uc.GroupOriginSetId = uc.ClassCode + uc.GroupUserId;

        uc.StaffUserId = tempUserClass[i].StaffUserId;
        uc.StaffUserIdOrigin = tempUserClass[i].StaffUserId;
        uc.StaffUserIdBeforeInput = tempUserClass[i].StaffUserId;
        uc.StaffUserName = tempUserClass[i].StaffUserName;
        uc.StaffOriginSetId = uc.ClassCode + uc.GroupUserId + uc.StaffUserId;

        uc.AgentUserId = tempUserClass[i].AgentUserId;
        uc.AgentUserIdOrigin = tempUserClass[i].AgentUserId;
        uc.AgentUserIdBeforeInput = tempUserClass[i].AgentUserId;
        uc.AgentUserName = tempUserClass[i].AgentUserName;
        uc.AgentOriginSetId = uc.ClassCode + uc.GroupUserId + uc.StaffUserId + uc.AgentUserId;

        if (PlessViewUtils.isEmpty(uc.GroupUserId)) {
          uc.GroupUserAdd = true;
          uc.GroupUserEdit = false;
          uc.StaffUserEdit = false;
          uc.AgentUserEdit = false;
        }
        if (PlessViewUtils.isEmpty(uc.StaffUserId)) {
          uc.StaffUserAdd = !uc.GroupUserAdd;
          uc.StaffUserEdit = false;
          uc.AgentUserEdit = false;
        }
        if (PlessViewUtils.isEmpty(uc.AgentUserId)) {
          uc.AgentUserAdd = !uc.GroupUserAdd && !uc.StaffUserAdd;
          uc.AgentUserEdit = false;
        }

        // 操作用の行を挿入
        if (breakStaff !== '' && breakStaff !== uc.StaffUserId) {
          if (!PlessViewUtils.isEmpty(breakAgent)) {
            this.userClassList.push(
              this.createAddRowModel(disabled, false, false, true, breakClass, breakClassName, breakGroup, breakStaff)
            );
          }
        }
        if (breakGroup !== '' && breakGroup !== uc.GroupUserId || breakClass !== '' && breakClass !== uc.ClassCode) {
          if (!PlessViewUtils.isEmpty(breakStaff)) {
            this.userClassList.push(
              this.createAddRowModel(disabled, false, true, false, breakClass, breakClassName, breakGroup)
            );
          }
        }
        if (breakClass !== '' && breakClass !== uc.ClassCode) {
          if (!PlessViewUtils.isEmpty(breakGroup)) {
            this.userClassList.push(
              this.createAddRowModel(disabled, true, false, false, breakClass, breakClassName)
            );
          }
        }
        // コントロールブレイク変数に識別子を退避してモデル追加
        breakClass = uc.ClassCode;
        breakClassName = uc.ClassName;
        breakGroup = uc.GroupUserId;
        breakStaff = uc.StaffUserId;
        breakAgent = uc.AgentUserId;
        this.userClassList.push(uc);

        // [最終行]操作用の行を挿入
        if (tempUserClass.length - 1 == i && !PlessViewUtils.isEmpty(uc.AgentUserId)) {
          this.userClassList.push(
            this.createAddRowModel(disabled, false, false, true, breakClass, breakClassName, breakGroup, breakStaff)
          );
        }
        if (tempUserClass.length - 1 == i && !PlessViewUtils.isEmpty(uc.StaffUserId)) {
          this.userClassList.push(
            this.createAddRowModel(disabled, false, true, false, breakClass, breakClassName, breakGroup)
          );
        }
        if (tempUserClass.length - 1 == i  && !PlessViewUtils.isEmpty(uc.GroupUserId)) {
          this.userClassList.push(
            this.createAddRowModel(disabled, true, false, false, breakClass, breakClassName)
          );
        }
      }

      // グリッドスクロール先頭、編集フラグクリア
      this.kymw9009Component.dtg_UserClassList.scrollIntoView(0, 0);
      this.kymw9009Component.clearEditFlag();
    }

    // ユーザ階層の取得条件を退避
    if (requestVO == null) {
      this.getUserClassVO = new GetUserClassManagementModel();
      this.userClassList = new Array<any>();
    } else {
      this.getUserClassVO = requestVO;
    }
  }

  /**
   * 追加行モデルを作成する
   *
   * @param {boolean} disabled 操作可否
   * @param {boolean} gAdd グループ長追加ボタン有無
   * @param {boolean} sAdd 担当者追加ボタン有無
   * @param {boolean} aAdd 代行者追加ボタン有無
   * @param {string} breakClass 部門コード
   * @param {string} breakClassName 部門名
   * @param {string} breakGroup グループ長ID
   * @param {string} breakStaff 担当者ID
   * @returns {UserClassManagementModel} 追加行モデル
   * @memberof KYMW9009Model
   */
  private createAddRowModel(disabled: boolean, gAdd: boolean, sAdd: boolean, aAdd: boolean,
                            breakClass: string, breakClassName: string,
                            breakGroup: string = '', breakStaff: string = ''): UserClassManagementModel {

    const ucAdd: UserClassManagementModel = new UserClassManagementModel();
    ucAdd.Disabled = disabled;  // 操作可否
    ucAdd.OnlyOperation = true; // 操作専用
    ucAdd.setEditAll(false);    // 編集不可

    ucAdd.GroupUserAdd = gAdd;  // グループ長追加ボタン
    ucAdd.StaffUserAdd = sAdd;  // 担当者追加ボタン
    ucAdd.AgentUserAdd = aAdd;  // 代行者追加ボタン

    ucAdd.ClassCode = breakClass;
    ucAdd.ClassName = breakClassName;
    ucAdd.GroupUserId = breakGroup;
    ucAdd.GroupOriginSetId = breakClass + breakGroup;
    ucAdd.GroupUserIdOrigin = (sAdd || aAdd) ? breakGroup : '';
    ucAdd.StaffUserId = breakStaff;
    ucAdd.StaffOriginSetId = breakClass + breakGroup + breakStaff;
    ucAdd.StaffUserIdOrigin = (aAdd) ? breakStaff : '';
    ucAdd.AgentUserId = ''; 
    ucAdd.AgentOriginSetId = ''; 

    return ucAdd;
  }


  /**
   * データグリッド「ユーザ階層」の指定行に１行追加する
   *
   * @param {UserClassManagementModel} model 追加操作した行のモデル
   * @param {number} insertIndex 挿入行インデックス
   * @param {string} targetSource 追加イベント元の階層
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public addUserClassLine(model: UserClassManagementModel, insertIndex: number, targetSource: string): void {
    if (this.userClassList == null) {
      this.userClassList = new Array<UserClassManagementModel>();
    }
    // 権限による操作可否
    const disabled = this.kymw9009Component.isDispOnlyMode();
    // ランダム文字列
    const rdm = String(Math.random());

    // 挿入する行のモデル
    const uc: UserClassManagementModel = new UserClassManagementModel();
    uc.Disabled = disabled;  // 操作可否
    uc.Added = true;  // 追加行フラグON
    uc.ClassCode = model.ClassCode;
    uc.ClassName = model.ClassName;

    uc.GroupUserId = model.GroupUserId;
    uc.GroupUserName = model.GroupUserName;
    uc.GroupOriginSetId = model.GroupOriginSetId;
    uc.GroupUserCheck = model.GroupUserCheck;

    uc.StaffUserId = model.StaffUserId;
    uc.StaffUserName = model.StaffUserName;
    uc.StaffOriginSetId = model.StaffOriginSetId;
    uc.StaffUserCheck = model.StaffUserCheck;

    uc.AgentUserId = model.AgentUserId;
    uc.AgentUserName = model.AgentUserName;
    uc.AgentOriginSetId = model.AgentOriginSetId;
    uc.AgentUserCheck = model.AgentUserCheck;

    if (targetSource === KYMW9009Model.CLASS_GROUP) {
      uc.StaffUserAdd = true;
      uc.StaffUserEdit = false;
      uc.AgentUserEdit = false;
      uc.GroupOriginSetId = uc.GroupOriginSetId + rdm;  // 追加対象階層はマージされないようにする
    } else if (targetSource === KYMW9009Model.CLASS_STAFF) {
      uc.AgentUserAdd = true;
      uc.AgentUserEdit = false;
      uc.GroupUserIdOrigin = model.GroupUserIdOrigin;
      uc.StaffOriginSetId = uc.StaffOriginSetId + rdm;  // 追加対象階層はマージされないようにする
    } else if (targetSource === KYMW9009Model.CLASS_AGENT) {
      uc.GroupUserIdOrigin = model.GroupUserIdOrigin;
      uc.StaffUserIdOrigin = model.StaffUserIdOrigin;
      uc.AgentOriginSetId = uc.AgentOriginSetId + rdm;  // 追加対象階層はマージされないようにする
    }

    // 追加操作行のチェックをOFF
    model.GroupUserCheck = false;
    model.StaffUserCheck = false;
    model.AgentUserCheck = false;
    // 追加操作行フラグON
    model.OnlyOperation = true;

    // 挿入してリスト更新
    this.userClassList.splice(insertIndex, 0, uc);
    this.userClassList = this.userClassList;
  }

  /**
   * データグリッド内の「ユーザ名」を設定する
   *
   * @param {*} serverData サーバからのレスポンスのデータ部分
   * @param {GetOktaUserNameModel} requestVO サーバへのリクエスト内容
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public updateUserName(serverData: any, requestVO: GetOktaUserNameModel): void {
    
    // ユーザ階層管理一覧から対象Modelを取得
    const userClass: UserClassManagementModel = this.userClassList[requestVO.TargetIndex];
    // ユーザ名セット、チェックボックスをON
    const target = requestVO.TargetItemName;
    const name = serverData.OktaInfomation.UserNmKanji;
    userClass[target + 'UserIdBeforeInput'] = requestVO.UserId;
    userClass[target + 'UserName'] = name;
    userClass[target + 'UserError'] = false;
    userClass[target + 'UserCheck'] = true;

    // 同じ階層に反映
    this.reflectSameLevel(userClass, target);

    // ユーザ階層管理グリッド更新
    this.refreshUserClass();
  }

  /**
   * 同階層反映を行う
   *
   * @param {UserClassManagementModel} model データモデル
   * @param {string} target 対象階層
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public reflectSameLevel(model: UserClassManagementModel, target: string): void {
    // 同じ階層を更新
    if (target !== KYMW9009Model.CLASS_AGENT) {
      for (let i = Number(0); i < this.userClassList.length; i++) {
        const elm = this.userClassList[i];
        if (elm[target + 'OriginSetId'] === model[target + 'OriginSetId']) {
          elm[target + 'UserId'] = model[target + 'UserId'];
          elm[target + 'UserIdBeforeInput'] = model[target + 'UserId'];
          elm[target + 'UserName'] = model[target + 'UserName'];
          elm[target + 'UserCheck'] = model[target + 'UserCheck'];
        }
      }
    }
  }

  /**
   * 更新リクエスト成功時の処理を行う
   *
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public updateUserClassUpdateSuccess(): void {
    // 編集フラグクリア
    this.kymw9009Component.clearEditFlag();

    // 再検索、再描画
    this.kymw9009Component.displayUserClassManagementList(this.getGetUserClassVO());
  }

  /**
   * 更新リクエスト失敗時の処理を行う
   *
   * @param {Array<UserClassManagementModel>} requestVoList サーバへのリクエスト内容
   * @param {string} errCode エラーコード
   * @param {Array<string>} errStrings エラー対象配列（部門名、階層、ユーザID）※3要素判定済み
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public updateUserClassUpdateFailure(requestVoList: Array<UserClassManagementModel>, errCode: string, errStrings: Array<string>): void {

    const classCode = errStrings[0];
    const levelName = errStrings[1];
    const userId = errStrings[2];

    // 部門名取得
    let className = '';
    const classList = this.kymw9009Component.cmb_ClassCode.model.classList;
    classList.forEach((elm) => {
      if (classCode === elm.ClassCode) {
        className = elm.ClassName;
        return;
      }
    });

    // 階層名から Group or Staff or Agent 取得
    const level = this.convertLevelName2ItemName(levelName);

    // 入力欄のエラー背景色設定
    requestVoList.forEach((elm) => {
      if (classCode === elm.ClassCode && userId === elm[level + 'UserId']) {
        elm[level + 'UserError'] = true;
        this.refreshUserClass();
        return;
      }
    });
  
    // エラーダイアログ表示
    this.kymw9009Component.showAlertDialog(errCode, [className, levelName, userId]);
  }

  /**
   * 削除リクエスト後の処理を行う
   *
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public updateUserClassDeleted(): void {

    // 編集フラグクリア
    this.kymw9009Component.clearEditFlag();

    // 再検索、再描画
    this.kymw9009Component.displayUserClassManagementList(this.getGetUserClassVO());
  }

  /**
   * データグリッド「Okta情報一覧」を設定する
   *
   * @param {*} serverData サーバからのレスポンスのデータ部分
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public updateOktaInfoList(serverData: any): void {
    this.oktaInfoList = new Array<any>();

    // データをセット
    if (serverData != null) {
      // 1 件以上の場合
      const tempOktaInfoList: Array<any> = serverData.OktaInfomationList;

      for (let i = Number(0); i < tempOktaInfoList.length; i++) {
        const oktaInfo: any = new Object();
        oktaInfo.UserId = tempOktaInfoList[i].UserId;
        oktaInfo.UserNmKanji = tempOktaInfoList[i].UserNmKanji;
        oktaInfo.UserDeptNm = tempOktaInfoList[i].UserDeptNm;
        oktaInfo.CrossId = tempOktaInfoList[i].CrossId;

        this.oktaInfoList.push(oktaInfo);
      }

      // スクロール
      this.kymw9009Component.dtg_OktInfoList.scrollIntoView(0, 0);
    }
  }

  /**
   * データグリッド「ユーザ階層管理」の表示を更新する（セルの値を変更後に使用）
   *
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public refreshUserClass(): void {
    this.kymw9009Component.dtg_UserClassList.refresh();
  }

  /**
   * 入力エラーをリセットする
   *
   * @returns {void}
   * @memberof KYMW9009Model
   */
  public resetInputError(): void {
    this.userClassList.forEach((elm) => {
      elm.GroupUserError = false;
      elm.StaffUserError = false;
      elm.AgentUserError = false;
    });
  }

  /**
   * 日本語階層名から、英字階層名に変換する
   *
   * @param {string} source 日本語階層名
   * @returns {string} 英字階層名
   * @memberof KYMW9009Model
   */
  private convertLevelName2ItemName(source: string): string {
    let target = '';
    if (PlessViewUtils.isEmpty(source)) {
      return target;
    }
    if (source === KYMW9009Model.CLASS_GROUP_NAME) {
      target = KYMW9009Model.CLASS_GROUP;
    } else if (source === KYMW9009Model.CLASS_STAFF_NAME) {
      target = KYMW9009Model.CLASS_STAFF;
    } else if (source === KYMW9009Model.CLASS_AGENT_NAME) {
      target = KYMW9009Model.CLASS_AGENT;
    }
    return target;
  }

  /**
   * ユーザ階層の取得条件を返す
   *
   * @returns {GetUserClassManagementModel} ユーザ階層の取得条件
   * @memberof KYMW9009Model
   */
  public getGetUserClassVO(): GetUserClassManagementModel {
    return this.getUserClassVO;
  }
}
